import { useEffect, useState } from "react";

import {
  fetchMerchantDebugContext,
  type MerchantDebugContext,
} from "@/application/merchants/debug_context_repository";

/**
 * Loads the merchant debug context, but only once `active` is true.
 *
 * The query behind it fans out to six data sources plus Cognito and
 * Amplitude, so the panels that need it fetch when opened rather than when
 * the overlay linking to them renders.
 */
export function useDebugContext(businessId: string, active: boolean) {
  const [context, setContext] = useState<MerchantDebugContext | null>(null);
  const [error, setError] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!active) return;

    let cancelled = false;
    setLoading(true);
    setError(null);

    fetchMerchantDebugContext(businessId)
      .then((result) => {
        if (!cancelled) setContext(result);
      })
      .catch((e: Error) => {
        if (!cancelled) setError(e.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [businessId, active]);

  return { context, error, loading };
}
